import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getLeadList = createAsyncThunk("/get-lead-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-leads`, data, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    console.log("API Response:", response.data); // This will show: {success, message, page, size, leads}
    return response.data; // Return the entire data object
  } catch (error) {
    console.error("Error fetching Leads", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Leads");
  }
});